export default __webpack_public_path__ + "static/media/000_intro_part1.last.c0cf2d81.avif";